import { render, staticRenderFns } from "./SmsList.vue?vue&type=template&id=245689f4&"
import script from "./SmsList.vue?vue&type=script&lang=ts&"
export * from "./SmsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports